import { ASSETS_URL, ReviewProduct, ReviewType, VideoReview } from '../../types';
import poster from '@/static/assets/reviews/Sandra_Pet/video.jpg';
import subs from '@/static/assets/reviews/Sandra_Pet/subs.vtt';

export const Sandra: VideoReview = {
  type: ReviewType.Video,
  product: [ReviewProduct.Pet, ReviewProduct.All],
  reviewerName: 'Sandra',
  videoUrl: `${ASSETS_URL}/pet/Sandra_Pet.webm`,
  posterUrl: poster,
  captionsUrl: subs,
};
